// extracted by mini-css-extract-plugin
export var accordion = "_e4-0";
export var chevron = "_e4-3";
export var closed = "_e4-2";
export var content = "_e4-4";
export var open = "_e4-1";
export var rotate = "_e4-5";